<template>
  <h2>
    「スーシェフ」は料理のレシピ、及び、タイマーを管理するアプリです。
  </h2>
  <p>※使用の際には広告を閲覧していただくことになりますが、定期購読で広告を非表示にすることが可能です。</p>

  <UpdatedView/>
  <br>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import UpdatedView from '@/components/UpdatedView.vue';

export default defineComponent({
  name: 'HomeView',
  components: {
    HelloWorld,
    UpdatedView
  },
});
</script>
